/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import {
  CreateAttributeProps,
  CreateFeatureProps,
  CreateSectionOptionProps,
  CreateValueProps,
  DeleteAttributeProps,
  DeleteFeatureProps,
  DeleteSectionOptionProps,
  DeleteValueProps,
  GetCostumeValuesProps,
  IImportCostumeTypeArgs,
  UpdateAttributeProps,
  UpdateFeatureProps,
  UpdatePresentationProps,
  UpdateSectionOptionProps,
  UpdateValueProps,
} from "./components";
import {
  CreateSectionProps,
  DeleteSectionProps,
} from "./components/section.service";

const is = require("is_js");

const SERVICE_NAME = "PresentationPageService";
const log: any = LoggerModule.getInstance();

export class PresentationPageService {
  private static instance: PresentationPageService;
  private vapp: VApplication;
  private headers: any;
  private nodesCollapsed = {};

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): PresentationPageService {
    if (!PresentationPageService.instance) {
      PresentationPageService.instance = new PresentationPageService(props);
    }
    return PresentationPageService.instance;
  }

  public getCollapsedNodes = () => {
    return this.nodesCollapsed;
  };

  public setCollapsedNodes = (nodes: any) => {
    this.nodesCollapsed = nodes;
  };

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = {
        ...content,
        ...compProps,
      };
    }

    return content;
  }

  public async getPageContent(args: any) {
    const agent = getAgent();
    const content = await agent.getPresentationProps({
      ...args,
    });

    console.log("Calleddd Presentation service", content);
    return content;
  }

  public async updatePresentation(args: UpdatePresentationProps) {
    const agent = getAgent();
    return agent.updatePresentation(args);
  }

  public async createSection(args: CreateSectionProps) {
    const agent = getAgent();
    return agent.createSection(args);
  }

  public async updateSection(args: UpdatePresentationProps) {
    const agent = getAgent();
    return agent.updateSection(args);
  }

  public async deleteSection(args: DeleteSectionProps) {
    const agent = getAgent();
    return agent.deleteSection(args);
  }

  public async createSectionOption(args: CreateSectionOptionProps) {
    const agent = getAgent();
    return agent.createSectionOption(args);
  }

  public async updateSectionOption(args: UpdateSectionOptionProps) {
    const agent = getAgent();
    return agent.updateSectionOption(args);
  }

  public async deleteSectionOption(args: DeleteSectionOptionProps) {
    const agent = getAgent();
    return agent.deleteSectionOption(args);
  }

  public async createFeature(args: CreateFeatureProps) {
    const agent = getAgent();
    return agent.createFeature(args);
  }

  public async updateFeature(args: UpdateFeatureProps) {
    const agent = getAgent();
    return agent.updateFeature(args);
  }

  public async deleteFeature(args: DeleteFeatureProps) {
    const agent = getAgent();
    return agent.deleteFeature(args);
  }

  public async createAttribute(args: CreateAttributeProps) {
    const agent = getAgent();
    return agent.createAttribute(args);
  }

  public async updateAttribute(args: UpdateAttributeProps) {
    const agent = getAgent();
    return agent.updateAttribute(args);
  }

  public async deleteAttribute(args: DeleteAttributeProps) {
    const agent = getAgent();
    return agent.deleteAttribute(args);
  }

  public async createValue(args: CreateValueProps) {
    const agent = getAgent();
    return agent.createValue(args);
  }

  public async updateValue(args: UpdateValueProps) {
    const agent = getAgent();
    return agent.updateValue(args);
  }

  public async deleteValue(args: DeleteValueProps) {
    const agent = getAgent();
    return agent.deleteValue(args);
  }

  public async importCostumeType(args: IImportCostumeTypeArgs) {
    const agent = getAgent();
    return agent.importCostumeType(args);
  }

  public async getCostumeValues(args: GetCostumeValuesProps) {
    const agent = getAgent();
    return agent.getCostumeValues(args);
  }
}
